import React, { createContext, useContext, useState } from 'react';

const AnimationContext = createContext();

export const AnimationProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState(null);
  const [previousSection, setPreviousSection] = useState(null);

  const updateActiveSection = (newSection) => {
    setPreviousSection(activeSection);
    setActiveSection(newSection);
  };

  return (
    <AnimationContext.Provider value={{ 
      activeSection, 
      previousSection,
      setActiveSection: updateActiveSection 
    }}>
      {children}
    </AnimationContext.Provider>
  );
};

export const useAnimationContext = () => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error('useAnimationContext must be used within an AnimationProvider');
  }
  return context;
}; 